import React, { useState, useEffect } from "react";
import {  GlobalService } from "./../../shared";
import {CardHeader,CardTitle,CardContent} from "../../../components/ui/card";
import Card from "../../../components/ui/card";
import { Eye, EyeOff, ArrowLeft, Mail, Lock, UserRound, CircleAlert } from "lucide-react";
import { motion } from "framer-motion";
import { ConfirmEmail, ResendEmail, ResetPassword, useAppDispatch } from "../../../redux";
import { ResetErrorsType } from "../../shared/model/AuthInterfaces";
import CommonLoginLeftPart from "./CommonLoginLeftPart";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Spinner from "../../shared/components/Spinner";
import { useSelector } from "react-redux";
import { selectLoaderValue } from "../../../redux/Slices/loadingSlice";
import { useTranslation } from "react-i18next";
import LanguageSelector from "../../../components/LanguageSelector";

const ConfirmUserComponent = () => {
    const { t } = useTranslation();
    const isLoading = useSelector(selectLoaderValue);
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [confirmUserInfo, setConfirmUserInfo] = useState<{ id: string; email: string } | null>(null);

    useEffect(() => {
        const getConfirmUserInfo = async () => {
            try {
                const storedValue = await GlobalService.getStorage("confirmUserInfo");
                if (storedValue) {
                    const parsedValue = JSON.parse(storedValue);
                    setConfirmUserInfo(parsedValue);
                }
                    } catch (error) {
                        throw error;
        }
        };

        getConfirmUserInfo();
    }, []);

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const hashFromURL = queryParams.get("hash");

        if (hashFromURL) {
            sendHash(hashFromURL);
        }
    }, [location.search]);
    const sendHash = async (hash: string) => {
        try {
            await dispatch(ConfirmEmail({ hash })).unwrap();
            navigate("/auth/login"); // ✅ do this here
        } catch (err) {
            throw err;
        }
    };
    const handleSubmit = async e => {
        if (!isLoading) {
            e.preventDefault();
            try {
                await dispatch(ResendEmail(confirmUserInfo)).unwrap();
            } catch (err) {
                throw err;
            }
        } else {
            GlobalService.showToast("info", t("confirmEmail.pleaseWait"), t("confirmEmail.processingRequest"));
        }
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-gray-100 flex flex-col p-4">
            {/* Navigation Header */}
            <div className="max-w-7xl mx-auto w-full py-6 px-4">
                <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    className="flex items-center justify-between">
                    <Link
                        to={"/"}
                        className="flex items-center gap-2 text-gray-600 hover:text-blue-600 transition-colors">
                        <ArrowLeft className="w-5 h-5" />
                        <span>{t("confirmEmail.backToHome")}</span>
                    </Link>
                    <LanguageSelector />
                </motion.div>
            </div>

            {/* Main Content */}
            <div className="flex-1 flex items-center justify-center">
                <div className="w-full max-w-4xl grid md:grid-cols-2 gap-8 items-center p-4">
                    {/* Left Side - Information */}
                    <CommonLoginLeftPart />

                    {/* Right Side - Login Form */}

                    <motion.div
                        initial={{ opacity: 0, x: 20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ delay: 0.3 }}>
                        <Card className="border-0 shadow-2xl bg-white/80 backdrop-blur" color={undefined}>
                            <CardHeader className="pb-6" color={undefined}>
                                <div className="md:hidden  flex justify-center">
                                    <div className="text-2xl font-extrabold text-blue-600 flex items-center gap-3">
                                        <img
                                            src="https://assests.netlify.app/assets/images/logo.png"
                                            alt="Kokobeo Logo"
                                            className="w-10 h-10 object-contain"
                                        />
                                        <span>Kokobeo</span>
                                    </div>
                                </div>
                                <CardTitle className="text-2xl font-bold text-center text-gray-900" color={undefined}>
                                    {t("confirmEmail.title")}
                                </CardTitle>
                                <p className="mt-2 text-sm text-gray-600 text-center">
                                    {t("confirmEmail.subtitle")}
                                </p>
                            </CardHeader>

                            <CardContent className="space-y-4">
                                {/* Divider */}
                                <div className="relative">
                                    <div className="absolute inset-0 flex items-center">
                                        <div className="w-full border-t border-gray-200" />
                                    </div>
                                    <div className="relative flex justify-center text-sm">
                                        <span className="px-4 text-gray-500 bg-white">{t("confirmEmail.orResend")}</span>
                                    </div>
                                </div>
                                <motion.button
                                    onClick={handleSubmit}
                                    whileHover={{ scale: 1.02 }}
                                    whileTap={{ scale: 0.98 }}
                                    className="w-full h-12 bg-blue-600 text-white rounded-lg hover:bg-blue-700 
                    transition-colors font-medium flex items-center justify-center gap-2">
                                    {isLoading ? (
                                        <>
                                            <Spinner size={5} />
                                            {t("confirmEmail.loading")}
                                        </>
                                    ) : (
                                        t("confirmEmail.resendButton")
                                    )}{" "}
                                </motion.button>

                                {/* Registration Link */}
                                {/* <p className="text-sm text-center text-gray-600">
                                    Don&apos;t have an account?{" "}
                                    <Link to={"/auth/register"}>
                                    <motion.button
                                        whileHover={{ scale: 1.05 }}
                                        className="text-blue-600 hover:text-blue-700 hover:underline font-medium">
                                                    Sign up here
                                    </motion.button>
                                    </Link>
                                </p> */}
                            </CardContent>
                        </Card>
                    </motion.div>
                </div>
            </div>
        </div>
    );
};

export default ConfirmUserComponent;
